import api from "@/api";

export default class EmailService {
  async send(document: string) {
    await api.post("/api/email/code/send", { document });
  }

  async verify(document: string, code: string) {
    await api.post("/api/email/code/verify", { document, code });
  }
}
